<template>
  <div id="default-layout-content" style="height: 100%;">
    <!-- navbar -->
    <navbar
      :viewWidth="windowWidth"
      :user="$store.state.currentUser"
      :logoutFunction="logout"
      :loginFunction="login"
      :has-sidebar="hasSidebar"
      :sidebar-items="sidebarItems"
    >
    </navbar>
    <!--/navbar-->
    <slot />
    <bottom-nav
      :viewWidth="windowWidth"
      :user="$store.state.currentUser"
    ></bottom-nav>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Navbar from "@/components/Navbar.vue";
import BottomNav from "@/components/BottomNav.vue";

export default {
  props: {
    hasSidebar: {
      type: Boolean,
      default: false
    },
    sidebarItems: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Navbar,
    BottomNav
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  data() {
    return {
      windowWidth: 0,
      sidebarIsMini: false,
      showSidebar: true
    };
  },
  methods: {
    ...mapMutations(["removeCurrentUser", "removeCredentials"]),
    handleWindowResize() {
      this.windowWidth = window.innerWidth;
    },
    login() {
      this.$router.replace({ name: "login" });
    },
    logout() {
      this.removeCurrentUser();
      this.removeCredentials();
      this.login();
    }
  }
};
</script>

<style>
#default-layout-content,
#default-layout-bottom {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
